import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  version: "1.1",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "20px",
  height: "20px",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { transform: "matrix(1 0 0 1 -481 -297 )" }, [
      _createElementVNode("path", {
        d: "M 491 297  C 496.6 297  501 301.4  501 307  C 501 312.6  496.6 317  491 317  C 485.4 317  481 312.6  481 307  C 481 301.4  485.4 297  491 297  Z ",
        "fill-rule": "nonzero",
        fill: "#f7f7f7",
        stroke: "none"
      }),
      _createElementVNode("path", {
        d: "M 491 297.5  C 496.32 297.5  500.5 301.68  500.5 307  C 500.5 312.32  496.32 316.5  491 316.5  C 485.68 316.5  481.5 312.32  481.5 307  C 481.5 301.68  485.68 297.5  491 297.5  Z ",
        "stroke-width": "1",
        stroke: "#e7ebeb",
        fill: "none"
      })
    ], -1)
  ])))
}
export default { render: render }